import * as t from 'io-ts';
import { BaseEntity, BaseEntityType } from '../../Global/models/baseEntity';

export const ChatType = t.interface({
    id: t.string,
    user: BaseEntityType,
    assignee: t.union([BaseEntityType, t.null, t.undefined]),
});

export interface ChatDto extends t.TypeOf<typeof ChatType> {
}

class Chat {
    id: string;
    user: BaseEntity;
    assignee: BaseEntity | null;

    constructor(params: ChatDto) {
        this.id       = params.id;
        this.user     = new BaseEntity(params.user);
        this.assignee = params.assignee
            ? new BaseEntity(params.assignee)
            : null;
    }
}

export default Chat;
